// extracted by mini-css-extract-plugin
module.exports = {"row":"Counter_row__1C_4f","value":"Counter_value__1d0te","button":"Counter_button__1xpSV","textbox":"Counter_textbox__3ODaX"};